module.exports = __webpack_public_path__ + "img/esmeralda-gym.5480c1de.jpg";